import { PermissionsService } from '@appStore/configuration/services/permission.service';

export const services: any[] = [PermissionsService];

export * from '@appStore/configuration/services/permission.service';
